export default {"src":"/fly/_next/static/media/person.5bf54f4b.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};